import { http } from '@/app/lib/http/client'
import { Paginator } from './banner.service'

export type CarouselDisplayType =
  | 'MANUAL'
  | 'BEST_SELLERS'
  | 'NEWEST'
  | 'PROMOTIONS'
  | 'CATEGORY'
  | 'DEPARTMENT'
  | 'PRODUCT_TYPE'

export interface StoreProductCarouselItem {
  id?: number
  carousel_id?: number
  product_id: number
  sort_order: number
  is_active: boolean
  product?: {
    id: number
    name: string
    [key: string]: any
  }
}

export interface StoreProductCarousel {
  id: number
  company: number
  name: string
  title: string | null
  subtitle: string | null
  display_type: CarouselDisplayType
  category_id: number | null
  department_id: number | null
  product_type_id: number | null
  items_limit: number
  is_active: boolean
  created_at?: string
  updated_at?: string
  items?: StoreProductCarouselItem[]
}

export const carouselService = {
  async getCarousels(params?: { page?: number; per_page?: number; search?: string }): Promise<{ data: Paginator<StoreProductCarousel> }> {
    const response = await http.get('/ecommerce/carousels', { params })
    return response.data
  },

  async getCarousel(id: number): Promise<StoreProductCarousel> {
    const response = await http.get(`/ecommerce/carousels/${id}`)
    return response.data.data
  },

  async createCarousel(data: Partial<StoreProductCarousel>): Promise<StoreProductCarousel> {
    const response = await http.post('/ecommerce/carousels', data)
    return response.data.data
  },

  async updateCarousel(id: number, data: Partial<StoreProductCarousel>): Promise<StoreProductCarousel> {
    const response = await http.put(`/ecommerce/carousels/${id}`, data)
    return response.data.data
  },

  async deleteCarousel(id: number): Promise<void> {
    await http.delete(`/ecommerce/carousels/${id}`)
  },

  async toggleCarouselStatus(id: number): Promise<void> {
    await http.patch(`/ecommerce/carousels/${id}/status`)
  },
}
